export const hideOverflowing = (isOpen) => {
  if (isOpen) document.body.classList.add("overflow-hidden");
  else document.body.classList.remove("overflow-hidden");
};
